import { render, staticRenderFns } from "./PermissionGroup.vue?vue&type=template&id=beb0f590&"
import script from "./PermissionGroup.vue?vue&type=script&lang=js&"
export * from "./PermissionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports